import React from 'react'
import PropTypes from 'prop-types'
import { PLAYBOOK_STEP_MAP } from 'utils/adminExperienceHelpers'
import TierLabel from 'components/TierLabel'
import { isFlagOn } from 'utils/featureFlags'
import {
  StyledHeaderTwo,
  SummaryLink,
  TierPill,
  TopWrapper,
} from '../component.styles'
import {
  DATE_TEST_FLAG,
  HEADER_TEXT_DEFAULT,
  HEADER_TEXT_SUMMARY,
  SUMMARY_LINK_TEXT,
} from '../constants'

const PlaybookHeader = ({
  hasAllStepsCompleted,
  onOpenSummaryModal,
  showMonitorViewOnly,
  showSummary,
}) => (
  <TopWrapper showMonitorViewOnly={showMonitorViewOnly}>
    <StyledHeaderTwo>
      {showMonitorViewOnly
        ? 'School Progress'
        : showSummary
        ? HEADER_TEXT_SUMMARY
        : HEADER_TEXT_DEFAULT}
    </StyledHeaderTwo>
    {!showMonitorViewOnly && hasAllStepsCompleted && (
      <SummaryLink onClick={onOpenSummaryModal}>
        {SUMMARY_LINK_TEXT}
      </SummaryLink>
    )}
    {showMonitorViewOnly && (
      <TierPill>
        <TierLabel
          labelText={
            isFlagOn([DATE_TEST_FLAG])
              ? PLAYBOOK_STEP_MAP.tierLabelTest
              : PLAYBOOK_STEP_MAP.tierLabel
          }
        />
      </TierPill>
    )}
  </TopWrapper>
)

PlaybookHeader.propTypes = {
  hasAllStepsCompleted: PropTypes.bool,
  onOpenSummaryModal: PropTypes.func,
  showMonitorViewOnly: PropTypes.bool,
  showSummary: PropTypes.bool,
}

export default PlaybookHeader
